(function () {
  if (window.__eldraWishlistLauncherBound) return;
  window.__eldraWishlistLauncherBound = true;

  var IT_LABELS = {
    'add to wishlist': 'Aggiungi alla wishlist',
    'added to wishlist': 'In wishlist',
    'remove from wishlist': 'Rimuovi dalla wishlist',
    'in wishlist': 'In wishlist',
    'my wishlist': 'La tua wishlist',
    'search item': 'Cerca',
    'search items': 'Cerca',
    'move to cart': 'Aggiungi al carrello',
    'select all': 'Seleziona tutto',
    'delete all': 'Elimina',
    'delete': 'Elimina',
    'share wishlist': 'Condividi',
    'login': 'Accedi',
    'no item found': 'Nessun prodotto trovato',
    'no products!': 'Nessun prodotto',
    'no products': 'Nessun prodotto',
    'no product!': 'Nessun prodotto',
    'no product': 'Nessun prodotto',
    'no items': 'Nessun prodotto',
    'your wishlist is empty': 'La tua wishlist è vuota',
    'wishlist is empty': 'La wishlist è vuota',
    'product successfully added to your wishlist': 'Aggiunto alla wishlist',
    'product added to your wishlist': 'Aggiunto alla wishlist',
    'item added to your wishlist': 'Aggiunto alla wishlist',
    'successfully added to your wishlist': 'Aggiunto alla wishlist',
    'product successfully removed from your wishlist': 'Rimosso dalla wishlist',
    'product removed from your wishlist': 'Rimosso dalla wishlist',
    'item removed from your wishlist': 'Rimosso dalla wishlist',
    'successfully removed from your wishlist': 'Rimosso dalla wishlist',
    'please login to add this product into wishlist': 'Accedi per aggiungere alla wishlist',
    'please login to add product in wishlist': 'Accedi per aggiungere alla wishlist',
    'please log in to add this product into wishlist': 'Accedi per aggiungere alla wishlist',
    'item added to your cart.': 'Aggiunto al carrello',
    'item added to your cart': 'Aggiunto al carrello',
    'wishlist url copied successfully!': 'Link della wishlist copiato',
    'wishlist url copied successfully': 'Link della wishlist copiato'
  };

  function hideAppLauncher() {
    document.querySelectorAll('button.wishlist-fix.wishlist-page-widget, button.wishlist-fix').forEach(function (el) {
      el.remove();
    });
  }

  function italianLabel(text) {
    var key = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return IT_LABELS[key] || '';
  }

  function italianToast(text) {
    var exact = italianLabel(text);
    if (exact) return exact;
    var low = (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (!low) return '';
    if (/log ?in/.test(low)) return 'Accedi per aggiungere alla wishlist';
    if (/copied/.test(low)) return 'Link della wishlist copiato';
    if (/already/.test(low) && /wishlist/.test(low)) return 'È già nella wishlist';
    if (/(removed|remove)/.test(low) && /wishlist/.test(low)) return 'Rimosso dalla wishlist';
    if (/(added|add)/.test(low) && /wishlist/.test(low)) return 'Aggiunto alla wishlist';
    if (/added/.test(low) && /cart/.test(low)) return 'Aggiunto al carrello';
    if (/sold out/.test(low)) return 'Prodotto esaurito';
    if (/^no products!?$/.test(low) || /^no product!?$/.test(low) || /^no items!?$/.test(low)) return 'Nessun prodotto';
    if (/^wishlist$/.test(low)) return 'La tua wishlist';
    return '';
  }

  function translateToast(root) {
    if (!root || root.nodeType !== 1 || !document.createTreeWalker) return;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walk.nextNode())) {
      var next = italianToast(node.nodeValue);
      if (next) node.nodeValue = next;
    }
  }

  function isWishlistPopup(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.wishlist-popup, [id^="wishlist-popup"]')) return true;
    return !!(node.id && String(node.id).indexOf('wishlist-popup') === 0);
  }

  function applyItalian(el) {
    if (!el) return;
    if (el.placeholder) {
      var ph = italianLabel(el.placeholder);
      if (ph) el.placeholder = ph;
    }
    var label = italianLabel(el.getAttribute && el.getAttribute('aria-label'));
    if (label) el.setAttribute('aria-label', label);
    var title = italianLabel(el.getAttribute && el.getAttribute('title'));
    if (title) el.setAttribute('title', title);
    if (el.childElementCount === 0) {
      var next = italianLabel(el.textContent);
      if (next && el.textContent.trim() !== next) el.textContent = next;
    }
  }

  function translateTree(root) {
    if (!root || !document.createTreeWalker) return;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walk.nextNode())) {
      var next = italianLabel(node.nodeValue) || italianToast(node.nodeValue);
      if (next) node.nodeValue = next;
    }
  }

  function polishWishlistButtons() {
    document.querySelectorAll('.wishlist-text, .wishlist-button-text').forEach(applyItalian);
    document.querySelectorAll('.eldra-wishlist-btn .wishlist-engine-button, .eldra-wishlist-btn .wishlist-engine a, .eldra-wishlist-btn .wishlist-engine button').forEach(function (el) {
      el.style.removeProperty('background');
      el.style.removeProperty('background-color');
      el.style.removeProperty('color');
    });
  }

  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return decodeURIComponent(parts.pop().split(';').shift() || '');
  }

  function wishlistShareUrl() {
    var uuid = getCookie('WISHLIST_UUID');
    var base = location.origin + '/apps/wishlist/';
    if (!uuid) return base;
    try {
      return base + '?share_id=' + btoa(uuid);
    } catch (err) {
      return base;
    }
  }

  function showShareCopiedToast() {
    if (document.getElementById('eldra-wishlist-copy-toast')) return;
    var el = document.createElement('div');
    el.id = 'eldra-wishlist-copy-toast';
    el.className = 'eldra-wishlist-copy-toast';
    el.textContent = 'Link della wishlist copiato';
    document.body.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 280);
    }, 2200);
  }

  function ensureShareRow() {
    var header = document.querySelector('.headerwishlist');
    if (!header || header.querySelector('.wishlist-share')) return;
    var heading = header.querySelector('.wishlist-heading');
    if (!heading) return;

    var ul = document.createElement('ul');
    ul.className = 'wishlist-share eldra-wishlist-share';
    ul.setAttribute('aria-label', 'Condividi la wishlist');
    ul.innerHTML =
      '<li><a href="javascript:void(0)" class="wishlist-share-triger" data-trigger="facebook" title="Condividi su Facebook" aria-label="Condividi su Facebook" role="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H8v3h2v7h3v-7h3l1-3h-4V10c0-.6.4-1 1-1z"/></svg></a></li>' +
      '<li><a href="javascript:void(0)" class="wishlist-share-triger" data-trigger="twitter" title="Condividi su X" aria-label="Condividi su X" role="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3.2 3h5.1l4.1 5.8L17.6 3H21l-7.1 8.3L21.5 21h-5.1l-4.5-6.4L5.2 21H2l7.6-8.9L3.2 3zm3.4 1.7 11.7 14.6h1.6L8.1 4.7H6.6z"/></svg></a></li>' +
      '<li><a href="javascript:void(0)" class="wishlist-share-triger" data-trigger="whatsapp" title="Condividi su WhatsApp" aria-label="Condividi su WhatsApp" role="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12.04 2C6.58 2 2.15 6.43 2.15 11.89c0 1.76.46 3.47 1.34 4.98L2 22l5.27-1.38a9.86 9.86 0 0 0 4.77 1.21h.01c5.46 0 9.89-4.43 9.89-9.89C21.94 6.43 17.5 2 12.04 2zm5.76 14.05c-.24.68-1.4 1.3-1.94 1.38-.5.07-1.13.1-1.82-.11-.42-.13-.96-.31-1.65-.61-2.9-1.25-4.79-4.17-4.93-4.36-.14-.19-1.15-1.53-1.15-2.92 0-1.39.73-2.07.99-2.35.26-.28.57-.35.76-.35h.55c.17 0 .41-.07.64.49.24.58.82 2 .89 2.15.07.15.12.32.02.52-.1.19-.15.32-.3.49-.15.17-.31.38-.45.51-.15.15-.3.31-.13.6.17.3.76 1.25 1.63 2.03 1.12 1 2.07 1.31 2.36 1.46.3.15.47.13.64-.08.17-.2.74-.86.94-1.16.2-.3.4-.25.67-.15.27.1 1.71.81 2 .95.3.15.49.22.56.34.08.13.08.73-.16 1.41z"/></svg></a></li>' +
      '<li><a href="javascript:void(0)" class="wishlist-share-triger" data-trigger="mail" title="Invia per email" aria-label="Invia per email" role="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"/></svg></a></li>' +
      '<li><a href="javascript:void(0)" class="wishlist-share-triger" data-trigger="link" title="Copia link" aria-label="Copia link" role="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M10.6 13.4a4 4 0 0 1 0-5.7l2.1-2.1a4 4 0 0 1 5.7 5.7l-1.5 1.5a1 1 0 0 1-1.4-1.4l1.5-1.5a2 2 0 1 0-2.8-2.8l-2.1 2.1a2 2 0 0 0 0 2.8 1 1 0 0 1-1.5 1.4zm2.8-2.8a1 1 0 0 1 0 1.4l-2.1 2.1a2 2 0 1 1-2.8-2.8l1.5-1.5a1 1 0 1 1 1.4 1.4l-1.5 1.5a2 2 0 0 0 2.8 0l2.1-2.1a1 1 0 0 1 1.4 0z"/></svg></a></li>';
    heading.after(ul);
  }

  function bindShareClicks() {
    if (window.__eldraWishlistShareClicks) return;
    window.__eldraWishlistShareClicks = true;
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest && event.target.closest('.eldra-wishlist-share .wishlist-share-triger');
      if (!a) return;
      event.preventDefault();
      event.stopPropagation();
      var url = wishlistShareUrl();
      var msg = 'Guarda la mia wishlist Eldra: ' + url;
      var type = a.getAttribute('data-trigger');
      if (type === 'facebook') {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank', 'noopener');
      } else if (type === 'twitter') {
        window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      } else if (type === 'whatsapp') {
        window.open('https://api.whatsapp.com/send?text=' + encodeURIComponent(msg), '_blank', 'noopener');
      } else if (type === 'mail') {
        window.location.href = 'mailto:?subject=' + encodeURIComponent('Guarda la mia wishlist Eldra') + '&body=' + encodeURIComponent(msg);
      } else if (type === 'link') {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showShareCopiedToast).catch(function () {
            window.prompt('Copia il link della wishlist', url);
          });
        } else {
          window.prompt('Copia il link della wishlist', url);
        }
      }
    });
  }

  function polishWishlistPage() {
    applyItalian(document.getElementById('wishlist-input'));
    document.querySelectorAll('.wishlist-heading').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^(my )?wishlist$/i.test(t)) el.textContent = 'La tua wishlist';
    });
    document.querySelectorAll(
      '.wishlist-heading, .headerwishlist, #wishlist-page-contain, .wishlist-container, .sewp-engine-popup, .wishlsitnoitem, [data-type="move-to-cart"], .wishlist-move-cart'
    ).forEach(function (root) {
      applyItalian(root);
      translateTree(root);
    });
    ensureShareRow();
  }

  function syncVariantId(input) {
    if (!input || !input.value) return;
    document.querySelectorAll('.eldra-wishlist-btn--pdp .wishlist-engine').forEach(function (el) {
      el.setAttribute('data-variant_id', input.value);
    });
  }

  function isWishlistRelated(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('button.wishlist-fix, .wishlist-popup, [id^="wishlist-popup"], .eldra-wishlist-btn, .wishlist-engine, .headerwishlist, .wishlist-share, .wishlist-heading, #wishlist-page-contain, .wishlist-container')) {
      return true;
    }
    return !!(node.querySelector && node.querySelector('button.wishlist-fix, .wishlist-popup, .eldra-wishlist-btn, .wishlist-engine, .headerwishlist, .wishlist-share'));
  }

  function watch() {
    hideAppLauncher();
    bindShareClicks();
    polishWishlistButtons();
    polishWishlistPage();

    var body = document.body;
    if (body && typeof MutationObserver !== 'undefined') {
      var polishTimer = 0;
      var scheduleButtonPolish = function () {
        if (polishTimer) return;
        polishTimer = window.setTimeout(function () {
          polishTimer = 0;
          polishWishlistButtons();
        }, 80);
      };

      var launcherObs = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var nodes = records[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches('button.wishlist-fix')) {
              node.remove();
              continue;
            }
            if (isWishlistPopup(node)) {
              translateToast(node);
              continue;
            }
            if (isWishlistRelated(node)) scheduleButtonPolish();
          }
        }
      });
      launcherObs.observe(body, { childList: true });

      document.querySelectorAll('.eldra-wishlist-btn').forEach(function (wrap) {
        var o = new MutationObserver(scheduleButtonPolish);
        o.observe(wrap, { childList: true, subtree: true });
      });

      if (location.pathname.indexOf('/apps/wishlist') !== -1) {
        var pageRoot = document.getElementById('MainContent') || document.querySelector('.content-for-layout') || body;
        if (pageRoot) {
          var pageTimer = 0;
          var pageObs = new MutationObserver(function () {
            if (pageTimer) return;
            pageTimer = window.setTimeout(function () {
              pageTimer = 0;
              polishWishlistPage();
            }, 80);
          });
          pageObs.observe(pageRoot, { childList: true, subtree: true });
        }
      }
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('form[action*="/cart/add"] [name="id"], product-form [name="id"]')) {
        syncVariantId(event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch, { once: true });
  } else {
    watch();
  }
})();
